import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-flow-builder-overview',
  templateUrl: './flow-builder-overview.component.html',
  styleUrls: ['./flow-builder-overview.component.scss']
})
export class FlowBuilderOverviewComponent {

  sideBarMinimized: boolean = true;
  sideBartoggle: boolean = true;

  constructor(
    public _autoMl:AutoMlService,
    private _cookie:CookieService
  ){}

  ngOnInit(){
    this._autoMl.token = this._cookie.get('token');
    this._autoMl.httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Token ${this._autoMl.token}`
    })
   }
    
  }


}
